import { render, staticRenderFns } from "./personnel.vue?vue&type=template&id=c4a1829e&scoped=true"
import script from "./personnel.vue?vue&type=script&lang=js"
export * from "./personnel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4a1829e",
  null
  
)

export default component.exports